import React from "react";
import { Link } from "react-router-dom";

function HomeScreenViewAllAppsView() {

  return (
    <div className="container text-center" style={{ marginTop: "5rem" }}>
      {/* Button browse all pdf tools */}
      <div className="mt-5">
        <Link
          to="/explore_apps"
          className="btn btn-primary px-5 py-3 fs-5 rounded-5"
          aria-label="View all PDF and image tools"
        >
          View All Tools
        </Link>
      </div>
    </div>
  );
}

export default HomeScreenViewAllAppsView;
